import React from "react";
import Icon, { type IconProps } from "./Icon";
/** UserMinus — Lucide. https://lucide.dev/icons/user-minus (MIT). Copied 2026-05-16.
 *  Phase 3d: AdminAudit user.deactivate scope marker. */
export default function UserMinus(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M2 21a8 8 0 0 1 13.292-6" />
      <circle cx="10" cy="8" r="5" />
      <line x1="22" x2="16" y1="11" y2="11" />
    </Icon>
  );
}
